/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import send from '../../utils/fetch'

export default {
  async UPDATE_PASSWORD({commit}, pass) {
    try {
      const { data } = await send(global.$url.user.update_password, 'POST', {data: pass})
      return data
    } catch (e) {
        return Promise.reject(e)
    }
  }
}
